(function (f, define) {
	define([], f);
})(function () {
	"use strict";

	const COLOR_SCHEME = "color-scheme";
	const VALID_THEMES = ["light", "dark", "system"];
	const THEME_MESSAGE_TYPE = "CORRIGO_THEME_CHANGE";

	(function () {
		window.corrigoTheme = window.corrigoTheme || {};

		const eventListeners = {
			change: []
		};

		const emit = (eventType, data) => {
			const listeners = eventListeners[eventType] || [];
			listeners.forEach(callback => {
				try {
					callback(data);
				} catch (error) {
					console.error(`Error in theme change listener:`, error);
				}
			});
		};

		/**
		 * Broadcast theme change to all iframes within the same page via postMessage
		 * Uses the current window's origin since bulk-import-ui is served from the same domain
		 * (e.g., USAZTCRGCCE9.corrigo-qa.com, customer.corrigo.com, etc.)
		 * The iframe at /corpnet/refrigerant/bulkupload.aspx is same-origin
		 */
		const broadcastThemeToIframes = (theme) => {
			try {
				const iframes = document.querySelectorAll('iframe');
				const currentOrigin = window.location.origin;

				iframes.forEach(iframe => {
					try {
						if (iframe.contentWindow) {
							// Send to same-origin iframes using current origin
							// This is secure because we specify the exact origin
							iframe.contentWindow.postMessage({
								type: THEME_MESSAGE_TYPE,
								theme: theme
							}, currentOrigin);
						}
					} catch (error) {
						// Ignore cross-origin errors for iframes we don't control
					}
				});
			} catch (error) {
				console.warn('Error broadcasting theme to iframes:', error);
			}
		};

		const setColorSchemeAttribute = () => {
			var theme = corrigoTheme.get();
			var resolvedTheme = theme == "system" ? corrigoTheme.getPreferred() : theme;
			document.documentElement.setAttribute("data-color-scheme", resolvedTheme);
			document.documentElement.style[COLOR_SCHEME] = theme == "system" ? null : theme;

			// Broadcast to embedded iframes
			broadcastThemeToIframes(resolvedTheme);
		};

		const handleSystemThemeChange = () => {
			setColorSchemeAttribute();

			emit('change');
		};

		corrigoTheme.setup = function (current) {
			if (window.matchMedia) {
				const darkMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
				darkMediaQuery.addEventListener("change", handleSystemThemeChange);

				const lightMediaQuery = window.matchMedia("(prefers-color-scheme: light)");
				lightMediaQuery.addEventListener("change", handleSystemThemeChange);
			}

			if (current)
				corrigoTheme.set(current);

			setColorSchemeAttribute();
		};

		corrigoTheme.get = function () {
			return localStorage.getItem(COLOR_SCHEME) || "light";
		};

		corrigoTheme.set = function (theme) {
			if (!VALID_THEMES.includes(theme)) {
				console.warn(`Invalid theme: ${theme}. Using default theme: light`);
				theme = 'light';
			}
			localStorage.setItem(COLOR_SCHEME, theme);
			handleSystemThemeChange();
		};

		corrigoTheme.getPreferred = function () {
			if (window.matchMedia) {
				if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
					return "dark";
				}
				if (window.matchMedia("(prefers-color-scheme: light)").matches) {
					return "light";
				}
			}
			return "light";
		};

		corrigoTheme.getMode = function () {
			var theme = corrigoTheme.get();
			return theme == "system" ? corrigoTheme.getPreferred() : theme;
		};

		corrigoTheme.onChange = function (callback) {
			if (typeof callback !== 'function') {
				console.error('Theme change listener must be a function');
				return;
			}

			eventListeners.change.push(callback);

			return function unsubscribe() {
				const index = eventListeners.change.indexOf(callback);
				if (index > -1) {
					eventListeners.change.splice(index, 1);
				}
			};
		};

		corrigoTheme.offChange = function (callback) {
			if (callback) {
				const index = eventListeners.change.indexOf(callback);
				if (index > -1) {
					eventListeners.change.splice(index, 1);
				}
			} else {
				eventListeners.change = [];
			}
		};

	})();

	return window.corrigoTheme;

}, typeof define == 'function' && define.amd ? define : function (_, f) {
	f();
});
